import { getDateTime, DateTimeFormats, getWeeknumber, monthNamesShort, monthNamesLong, dayNames, dayNamesShort } from "../Utils/DateTimeUtils";

export class DateBindingHandler implements KnockoutBindingHandler {
    constructor() {
        ko.virtualElements.allowedBindings.date = true;
    }

    public update(element: Node, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor) {
        let value = ko.unwrap(valueAccessor());
        let allBindings = allBindingsAccessor();
        let displayValue = value;

        let dateformat = allBindings.dateformat || 'datetime';
        switch (dateformat) {
            case 'datetime':
                displayValue = getDateTime(value) + ' ' + getDateTime(value, DateTimeFormats["HH:mm:ss"]);
                break;
            case 'date':
                displayValue = getDateTime(value);
                break;
            case 'time':
                displayValue = getDateTime(value, DateTimeFormats["HH:mm:ss"]);
                break;
            case 'shorttime':
                displayValue = getDateTime(value, DateTimeFormats["HH:mm"]);
                break;
            case 'shorttimeWithDesc':
                displayValue = getDateTime(value, DateTimeFormats["HH:mm"]);
                if (displayValue) {
                    displayValue += " uur";
                }
                break;
            // "Maandag", "Dinsdag", etc
            case 'day':
                if (value instanceof Date) {
                    displayValue = dayNames[value.getDay()];
                }
                break;
            case 'dayShort':
                if (value instanceof Date) {
                    displayValue = dayNamesShort[value.getDay()];
                }
                break;
            // "1 mrt", "23 sep", etc
            case 'dateShortMonth':
                if (value instanceof Date) {
                    displayValue = value.getDate() + ' ' + monthNamesShort[value.getMonth()];
                }
                break;
            case 'month':
                if (value instanceof Date) {
                    displayValue = monthNamesLong[value.getMonth()];
                }
                break;
            case 'monthShort':
                if (value instanceof Date) {
                    displayValue = monthNamesShort[value.getMonth()];
                }
                break;
            case 'monthYear':
                if (value instanceof Date) {
                    displayValue = monthNamesLong[value.getMonth()] + ' ' + value.getFullYear();
                }
                break;
            case 'monthShortYear':
                if (value instanceof Date) {
                    displayValue = monthNamesShort[value.getMonth()] + ' ' + value.getFullYear();
                }
                break;
            // "Week 9", "Week 53", etc
            case 'weeknumber':
                if (value instanceof Date) {
                    displayValue = getWeeknumber(value);
                }
                break;
            case 'dateShortYear':
                displayValue = getDateTime(value, DateTimeFormats["dd-MM-yy"]);
                break;
        }

        let isDatepicker = allBindings.widget !== undefined && allBindings.widget.type === $.ui.datepicker;
        if (isDatepicker) {
            $(element).val(displayValue);
        } else {
            ko.utils.setTextContent(element, displayValue);
        }
    }
}
